import { render, staticRenderFns } from "./CogAI.vue?vue&type=template&id=40c2017c&scoped=true&"
import script from "./CogAI.vue?vue&type=script&lang=js&"
export * from "./CogAI.vue?vue&type=script&lang=js&"
import style0 from "./CogAI.vue?vue&type=style&index=0&id=40c2017c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2017c",
  null
  
)

export default component.exports